import { css, cva } from "styled-system/css";

export { pageContainerStyles as page, pageHeaderStyles as header } from "#/app.css";
export {
  filterInputContainerStyles as filterInputContainer,
  filterInputStyles as filterInput,
  filterInputIconStyles as filterInputIcon,
} from "#/app.css";

export const title = css({
  fontSize: "h2",
  fontWeight: "900",
  letterSpacing: "-0.025em",
  color: "textBase",
});

export const refreshBtn = css({
  cursor: "pointer",
  transition: "all 200ms",
  userSelect: "none",
  border: "none",
  outline: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.5rem",
  borderRadius: "full",
  backgroundColor: "bgBase200",
  color: "textBase",
  _hover: {
    backgroundColor: "bgBase300",
  },
  _active: {
    transform: "rotate(45deg)",
  },
  _disabled: {
    opacity: 0.5,
    cursor: "not-allowed",
  },
});

export const spin = css({
  animation: "spin 1s linear infinite",
});

/* Filters */
export const filterContainer = css({
  marginBottom: "2rem",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
});

export const filterRow = css({
  display: "flex",
  flexDirection: {
    base: "row",
    md: "row",
  },
  alignItems: "center",
  gap: "0.75rem",
});

export const filterInputWrapper = css({
  position: "relative",
  flex: 1,
});

export const filterDropdown = css({
  position: "absolute",
  top: "100%",
  left: 0,
  right: 0,
  marginTop: "0.5rem",
  zIndex: 100,
  backgroundColor: "bgBase100",
  borderRadius: "0.75rem",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
  maxHeight: "300px",
  overflowY: "auto",
});

export const filterDropdownItem = css({
  width: "100%",
  padding: "0.75rem 1rem",
  textAlign: "left",
  fontSize: "14px",
  cursor: "pointer",
  backgroundColor: "transparent",
  border: "none",
  transition: "all 150ms",
  _hover: {
    backgroundColor: "bgBase200",
  },
});

export const sourceFilterWrapper = css({
  position: "relative",
});

export const sourceFilterButton = css({
  cursor: "pointer",
  transition: "all 200ms",
  userSelect: "none",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  outline: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: "2rem",
  height: "2rem",
  borderRadius: "full",
  backgroundColor: "bgBase100",
  color: "textBase/60",
  _hover: {
    borderColor: "textBase/40",
    color: "textBase",
  },
});

export const sourceDropdown = css({
  position: "absolute",
  top: "100%",
  right: 0,
  marginTop: "0.5rem",
  zIndex: 100,
  minWidth: "10rem",
  backgroundColor: "bgBase100",
  borderRadius: "0.75rem",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
  maxHeight: "300px",
  overflowY: "auto",
});

export const clearFiltersBtn = css({
  fontSize: "12px",
  fontWeight: "700",
  color: "primary",
  cursor: "pointer",
  padding: "0.5rem",
  backgroundColor: "transparent",
  border: "none",
  _hover: {
    textDecoration: "underline",
  },
});

export const filterChipsContainer = css({
  display: "flex",
  flexWrap: "wrap",
  gap: "0.5rem",
});

export const filterChip = css({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  padding: "0.375rem 0.75rem",
  borderRadius: "full",
  backgroundColor: "bgBase300",
  fontSize: "12px",
  fontWeight: "600",
});

export const filterChipButton = css({
  cursor: "pointer",
  opacity: 0.5,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "none",
  backgroundColor: "transparent",
  padding: 0,
  _hover: {
    opacity: 1,
  },
});

/* List */
export const listContainer = css({
  backgroundColor: "bgBase100",
  borderRadius: "1rem",
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "bgBase300",
  overflow: "hidden",
});

export const statusIconInline = css({
  marginRight: "0.75rem",
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
});

export const statusText = css({
  fontSize: "12px",
  fontWeight: "900",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
});

export const statusTextCompleted = css({ color: "success" });
export const statusTextCancelled = css({ color: "textBase/40" });
export const statusTextError = css({ color: "error" });
export const statusTextRunning = css({ color: "primary" });
export const statusTextQueued = css({ color: "warning" });
export const statusTextDefault = css({ color: "textBase/60" });

export const novelTitle = css({
  fontSize: "14px",
  fontWeight: "700",
  color: "textBase",
  textDecoration: "none",
  _hover: {
    color: "primary",
    textDecoration: "underline",
  },
});

export const bookIcon = css({
  marginRight: "0.5rem",
  width: "1rem",
  height: "1rem",
  opacity: 0.4,
});

export const infoMetaContainer = css({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  marginTop: "0.25rem",
  fontSize: "11px",
  opacity: 0.5,
});

export const infoSource = css({});
export const infoDivider = css({});
export const infoJobId = css({});

export const cancelBtn = css({
  color: "error",
  fontWeight: "700",
  fontSize: "12px",
  _hover: {
    backgroundColor: "error/10",
  },
});

export const timestamp = css({
  fontSize: "12px",
  opacity: 0.5,
  fontWeight: "500",
});

export const iconSmall = css({
  flexShrink: 0,
});

export const jobChaptersInfo = css({
  display: "flex",
  flexDirection: "column",
  gap: "0.125rem",
  marginTop: "0.25rem",
});

export const chapterInfoRow = css({
  fontSize: "10px",
  opacity: 0.5,
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const chapterInfoLabel = css({
  fontWeight: "700",
  flexShrink: 0,
});

export const extensionBadge = css({
  display: "inline-flex",
  alignItems: "center",
  gap: "2px",
  marginLeft: "0.5rem",
  padding: "1px 4px",
  borderRadius: "4px",
  backgroundColor: "bgBase300",
  color: "textBase/60",
});

export const extensionText = css({
  fontSize: "10px",
  fontWeight: "700",
  textTransform: "uppercase",
});

export const listFooter = css({
  padding: "1.5rem",
  textAlign: "center",
  fontSize: "14px",
  fontWeight: "700",
  opacity: 0.5,
  borderTopWidth: "1px",
  borderTopStyle: "solid",
  borderTopColor: "bgBase300",
});

export const mobileListItem = css({
  borderBottomWidth: "1px",
  borderBottomStyle: "solid",
  borderBottomColor: "bgBase200",
  borderRadius: 0,
  boxShadow: "none",
  borderInline: "none",
  borderTop: "none",
});

export const mobileCardInner = css({
  padding: "1rem !important",
});

export const mobileCardGrid = css({
  display: "flex",
  flexDirection: "column",
});

export const jobCardLeft = css({});
export const jobCardRight = css({});

export const loading = css({
  padding: "2rem",
  textAlign: "center",
  opacity: 0.5,
});

export const empty = css({
  padding: "4rem",
  textAlign: "center",
  opacity: 0.4,
  fontWeight: "700",
  fontStyle: "italic",
});
